"use strict";
/* eslint-disable camelcase */
Object.defineProperty(exports, "__esModule", { value: true });
exports.insightData = void 0;
var DeviceTypeMap = {
    desktop: 'desktop',
    tablet: 'tablet',
    mobile: 'mobile',
};
var getDomainName = function (canonicalUrl) {
    var domainName = new URL(canonicalUrl).hostname.replace(/(.*?\.)(\w+?\.\w+?)$/, '$2');
    if (domainName.includes('.') || domainName === 'localhost') {
        return domainName;
    }
    throw new TypeError("".concat(domainName, " is not a valid URL."));
};
function getDeviceShortName(deviceType) {
    if (deviceType) {
        return deviceType === DeviceTypeMap.mobile ? 'p' : deviceType.split('')[0];
    }
    return 'u';
}
// Replace underscore and whitespace with dash
var sanitizeUtmTags = function (str) { return str === null || str === void 0 ? void 0 : str.replace(/[_\s]/gi, '-'); };
var NO_DATA = 'missing';
function buildReferrerSourceList(config) {
    var urlRegexPattern = "(http|https)://(www|beta|local)?.?".concat(config.pub.domain.replace(/\./g, '\\.'));
    var referrer = config.referrer;
    /**
     * An array of posible referrers that we try to match against. The order of the array is important
     * so we can make assumptions in the second element, since it didn't match the first element.
     * The first element of the array is documented, and the rest follow the same format.
     * @type Array'
     */
    return [
        {
            /**
             * The short name of the referrer to be used in the first position of the source in insight.
             * @type String
             */
            shortName: config.pub.prefix,
            /**
             * A predicate function that will return true if the referrer matches
             * @type Function => Boolean
             */
            predicate: function () { return referrer.search(new RegExp(urlRegexPattern)) > -1; },
            /**
             * An optional array for additional info about the referrer. Eg: we know it's from aftenposten.no somewhere,
             * the additional info will try to find out if it came from a front page, article, section page etc.
             * The format of the additional info is exacly the same as the one documented here except it can not
             * have it's own additionalInfo.
             * @type Array
             */
            additionalInfo: [
                {
                    // 'w' is widget specifier for frontpage widgets set if 'r' query param is set on links from frontpage
                    shortName: "f".concat(config.variant.frontpage || '') +
                        "".concat(config.variant.article ? "w".concat(config.variant.article) : ''),
                    predicate: function () {
                        return referrer.search(new RegExp("".concat(urlRegexPattern, "/?$"))) > -1;
                    },
                },
                {
                    shortName: "a".concat(config.variant.article || ''),
                    predicate: function () { return referrer.search(/\/i\/[a-zA-Z0-9]+\//) > -1; },
                },
                {
                    shortName: "p1",
                    predicate: function () { return referrer.search(/restaurantguide/) > -1; },
                },
                {
                    shortName: 's',
                    predicate: function () {
                        return referrer.search(new RegExp("".concat(urlRegexPattern, "/([a-z-]+)[/]?$"))) >
                            -1;
                    },
                },
                {
                    shortName: 'o',
                    predicate: function () { return true; },
                },
            ],
        },
        {
            shortName: 'vg',
            predicate: function () { return referrer.search(/^(http|https):\/\/www\.vg\.no/) > -1; },
            additionalInfo: [
                {
                    shortName: 'f',
                    predicate: function () { return referrer.search(/vg\.no\/?(\?|$)/) > -1; },
                },
                {
                    shortName: 'a',
                    predicate: function () { return referrer.search(/\/i\/[a-zA-Z0-9]+\//) > -1; },
                },
            ],
        },
        {
            shortName: 'ap',
            predicate: function () {
                return referrer.search(/^(http|https):\/\/www\.aftenposten\.no/) > -1;
            },
            additionalInfo: [
                {
                    shortName: 'f',
                    predicate: function () { return referrer.search(/aftenposten\.no\/?(\?|$)/) > -1; },
                },
                {
                    shortName: 'a',
                    predicate: function () { return referrer.search(/\/i\/[a-zA-Z0-9]+\//) > -1; },
                },
            ],
        },
        {
            shortName: 'bt',
            predicate: function () { return referrer.search(/^(http|https):\/\/www\.bt\.no/) > -1; },
            additionalInfo: [
                {
                    shortName: 'f',
                    predicate: function () { return referrer.search(/bt\.no\/?(\?|$)/) > -1; },
                },
                {
                    shortName: 'a',
                    predicate: function () { return referrer.search(/\/i\/[a-zA-Z0-9]+\//) > -1; },
                },
            ],
        },
        {
            shortName: 'sa',
            predicate: function () {
                return referrer.search(/^(http|https):\/\/www\.aftenbladet\.no/) > -1;
            },
            additionalInfo: [
                {
                    shortName: 'f',
                    predicate: function () { return referrer.search(/aftenbladet\.no\/?(\?|$)/) > -1; },
                },
                {
                    shortName: 'a',
                    predicate: function () { return referrer.search(/\/i\/[a-zA-Z0-9]+\//) > -1; },
                },
            ],
        },
        {
            shortName: 'vink',
            predicate: function () { return referrer.search(/vink\.aftenposten\.no/) > -1; },
            additionalInfo: [
                {
                    shortName: 'f',
                    predicate: function () {
                        return referrer.search(/vink\.aftenposten\.no\/?(\?|$)/) > -1;
                    },
                },
                {
                    shortName: 's',
                    predicate: function () { return referrer.search(/\/mat-og-drikke/) > -1; },
                },
                {
                    shortName: 's',
                    predicate: function () { return referrer.search(/\/byliv-og-guider/) > -1; },
                },
                {
                    shortName: 's',
                    predicate: function () { return referrer.search(/\/film-og-serier/) > -1; },
                },
                {
                    shortName: 'a',
                    predicate: function () { return referrer.search(/\/artikkel\/[a-zA-Z0-9]+\//) > -1; },
                },
            ],
        },
        {
            shortName: 'FB',
            predicate: function () { return referrer.search(/facebook|messenger\.com/) > -1; },
            additionalInfo: [
                {
                    shortName: 'm',
                    predicate: function () { return referrer.search(/messenger\.com/) > -1; },
                },
                {
                    shortName: config.variant.rQuery,
                    predicate: function () { return config.variant.rQuery; },
                },
                {
                    shortName: 'u',
                    predicate: function () { return true; },
                },
            ],
        },
        {
            shortName: 'G',
            predicate: function () { return referrer.search(/google/) > -1; },
            additionalInfo: [
                {
                    shortName: config.variant.rQuery,
                    predicate: function () { return config.variant.rQuery; },
                },
                {
                    shortName: 'u',
                    predicate: function () { return true; },
                },
            ],
        },
        {
            shortName: 'ig',
            predicate: function () { return referrer.search(/instagram/) > -1; },
            additionalInfo: [
                {
                    shortName: config.variant.rQuery,
                    predicate: function () { return config.variant.rQuery; },
                },
                {
                    shortName: 'u',
                    predicate: function () { return true; },
                },
            ],
        },
        {
            shortName: 'Lnkd',
            predicate: function () { return referrer.search(/(linkedin)|(lnkd.in)/) > -1; },
            additionalInfo: [
                {
                    shortName: config.variant.rQuery,
                    predicate: function () { return config.variant.rQuery; },
                },
                {
                    shortName: 'u',
                    predicate: function () { return true; },
                },
            ],
        },
        {
            shortName: 'Snap',
            predicate: function () { return referrer.search(/snapchat/) > -1; },
            additionalInfo: [
                {
                    shortName: config.variant.rQuery,
                    predicate: function () { return config.variant.rQuery; },
                },
                {
                    shortName: 'u',
                    predicate: function () { return true; },
                },
            ],
        },
        {
            shortName: 'Sol',
            predicate: function () { return referrer.search(/sol\.no/) > -1; },
        },
        {
            shortName: 'Slack',
            predicate: function () { return referrer.search(/slack/) > -1; },
        },
        {
            shortName: 'O',
            predicate: function () { return true; },
        },
    ];
}
/**
 * Should be removed once URS migration is complete for all brands
 */
var insightData = function (baseProps, salesposterElem, docRef) {
    var deviceType = baseProps.deviceType, _a = baseProps.query, _b = _a === void 0 ? {} : _a, _c = _b.r, rQuery = _c === void 0 ? '' : _c, contentProvider = baseProps.contentProvider, _d = baseProps.contentId, contentId = _d === void 0 ? NO_DATA : _d, contentType = baseProps.contentType, _e = baseProps.hasSalesLeadBody, hasSalesLeadBody = _e === void 0 ? false : _e, frontpageVariant = baseProps.frontpageVariant, utmTags = baseProps.utmTags, windowLocationHref = baseProps.windowLocationHref;
    var documentReferrer = docRef.split(/[?#]/)[0];
    var referrerList = buildReferrerSourceList({
        pub: {
            prefix: contentProvider || NO_DATA,
            domain: getDomainName(windowLocationHref),
        },
        variant: {
            frontpage: frontpageVariant || '',
            article: rQuery,
            rQuery: rQuery,
        },
        referrer: documentReferrer,
    });
    var sourceRef = referrerList.filter(function (r) { return r.predicate(); }).shift();
    var additionalInfo = sourceRef.additionalInfo
        ? sourceRef.additionalInfo.filter(function (w) { return w.predicate(); }).shift()
        : { shortName: 'u' };
    var campaign = salesposterElem.campaign, posterType = salesposterElem.posterType;
    var salesLeadFlag = hasSalesLeadBody ? '-lead' : '';
    var referrerMedium = contentType === 'other'
        ? contentId
        : "".concat(contentType, "-").concat(contentProvider, "-").concat(contentId);
    var utm_content = (utmTags === null || utmTags === void 0 ? void 0 : utmTags.utm_content) || '';
    var utm_campaign = (utmTags === null || utmTags === void 0 ? void 0 : utmTags.utm_campaign) || '';
    var data = {
        source: "".concat(sourceRef.shortName, "-").concat(additionalInfo.shortName, "-").concat(getDeviceShortName(deviceType)),
        medium: referrerMedium,
        content: (sanitizeUtmTags(utm_content) || posterType || NO_DATA) + salesLeadFlag,
        campaign: sanitizeUtmTags(utm_campaign) || campaign || NO_DATA,
        tag: NO_DATA,
    };
    data.tag = "".concat(data.source, "_").concat(data.medium, "_").concat(data.content, "_").concat(data.campaign);
    return data;
};
exports.insightData = insightData;
//# sourceMappingURL=insight-params.js.map